import axios from 'axios';
const configurationsUrl = process.env.REACT_APP_CONFIGURATIONS;

export const getConfigurationsByFilters = async (token, queryFilters) => {
  const url = `${configurationsUrl}/v1/get-by-filters`;

  const requestOptions = {
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `bearer ${token}`,
    },
    params: {
      queryFilters: JSON.stringify(queryFilters),
    },
  };

  try {
    const response = await axios(url, requestOptions);
    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};

export const getNotificationsFilters = async (token, queryFilters) => {
  const url = `${configurationsUrl}/v1/get-notifications-filters`;
  const { organizationId } = queryFilters;

  const requestOptions = {
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `bearer ${token}`,
    },
    params: {
      organizationId,
    },
  };

  try {
    const response = await axios(url, requestOptions);
    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};

export const sendAndSaveNotificationFilters = async (params) => {
  try {
    const { token, documentId, organizationId, profile, filtersToUpdate } = params;
    const { email, firstName, lastName } = profile;
    const url = `${configurationsUrl}/v1/save-one/subcollection`;

    const requestOptions = {
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: {
        documentId,
        organizationId,
        filtersToUpdate,
        profile: { email, firstName, lastName },
      },
    };
    return axios(url, requestOptions);
  } catch (error) {
    console.log(`sendAndSaveNotificationFilters >> error:`, error);
    throw error;
  }
};
export const sendAndSaveAppointmentsFilters = async (params) => {
  try {
    const { token, documentId, newDocument, profile } = params;
    const { email, firstName, lastName } = profile;
    const url = `${configurationsUrl}/v1/save-one`;

    const requestOptions = {
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: {
        documentId,
        newDocument,
        profile: { email, firstName, lastName },
      },
    };
    await axios(url, requestOptions);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const sortArrayFilter = (filters) => {
  return filters && filters.sort((a, b) => a?.value?.localeCompare(b?.value));
};

export const generatePages = (specialties, elements) => {
  const elementsPerPage = elements || 20;

  if (specialties.length > 0) {
    return specialties.length % elementsPerPage === 0
      ? parseInt(specialties.length / elementsPerPage)
      : parseInt(specialties.length / elementsPerPage) + 1;
  } else return 0;
};

export const filterAndGetByValue = (valueFromSearch, arrayItems) => {
  let filteredItems = [];
  if (arrayItems.length > 0) {
    filteredItems = arrayItems.filter((item) =>
      item.value.toLowerCase().includes(valueFromSearch.toLowerCase()),
    );
  }
  return filteredItems;
};
export const deleteSpecialCharacters = (string) => {
  const e = string
    .replace(/[áéíóúÁÉÍÓÚ]/g, function (match) {
      return {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U',
      }[match];
    }) // Elimina las tildes
    .replace(/[^\w\sñÑ]/gi, '') // Elimina los caracteres especiales, pero mantiene la ñ y Ñ
    .trim();

  return e;
};

export const generateObjectToSend = (
  organizationId,
  professionalsToIgnoreExtra,
  professionalsToIgnore,
  specialtiesToIgnoreExtra,
  specialtiesToIgnore,
  insurancesToIgnoreExtra,
  insurancesToIgnore,
) => {
  return {
    organizationId,
    name: 'notificationFilters',
    professionalsToIgnoreExtra,
    professionalsToIgnore,
    specialtiesToIgnoreExtra,
    specialtiesToIgnore,
    insurancesToIgnoreExtra,
    insurancesToIgnore,
  };
};

export function updateOrAddToObjectArray(array, objectToUpdate) {
  try {
    // Busca si el objeto ya está en el array por su ID
    const index = array?.findIndex((obj) => obj?.id === objectToUpdate?.id);
    objectToUpdate.checked = !objectToUpdate.checked;
    // Si se encuentra el objeto en el array
    if (index !== -1) {
      // Actualiza el objeto en el array con el nuevo objeto
      array[index] = { ...objectToUpdate };
    } else {
      // Si no se encuentra, agrega el nuevo objeto al array
      array.push(objectToUpdate);
    }

    // Retorna el array actualizado
    return array;
  } catch (error) {
    console.log(`updateOrAddToObjectArray:`, error);
  }
}

export function mergeUpdatedOjectsArray(array = [], objectToUpdate) {
  try {
    // Itera sobre el nuevo array
    if (objectToUpdate) {
      objectToUpdate.forEach((newObj) => {
        // Busca si el objeto ya está en el array por su ID
        const index = array.findIndex((obj) => obj.id === newObj.id);

        // Si se encuentra el objeto en el array
        if (index !== -1) {
          // Elimina el objeto existente del array
          array.splice(index, 1);
        }

        // Agrega el nuevo objeto al array
        array.push(newObj);
      });
    }

    // Retorna el array actualizado
    return array;
  } catch (error) {
    console.log('mergeUpdatedOjectsArray', error);
  }
}

export const updateNotificationsWithFilters = async (organizationId) => {
  const url = `${configurationsUrl}/v1/update-notifications`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
    },
    data: {
      organizationId: organizationId,
    },
  };

  try {
    return axios(url, requestOptions);
  } catch (error) {
    console.log(`updateNotificationsWithFilters >> error:`, error);
    throw error;
  }
};
